export default {
  setCurrentLayout({ commit, state }, layoutName) {
    if (!layoutName) {
      throw new Error('layoutName is required!');
    }

    if (layoutName !== 'previous' && layoutName !== state.currentLayout) {
      commit('UPDATE_CURRENT_LAYOUT', layoutName);
    }
  },

  setLoadingState({ commit }, status) {
    if (typeof status !== 'boolean') {
      throw new Error('setLoadingState expects a boolean');
    }

    const targetMutation = status ? 'INCREMENT_LOADING_COUNT' : 'DECREMENT_LOADING_COUNT';

    commit(targetMutation);
  },
};
